import type { RouteLocationNormalized } from 'vue-router'

export const handleOrganizationQuery = (to: RouteLocationNormalized) => {
  const encodedOrganizationId = to.query.o as string | undefined

  if (!encodedOrganizationId) return null

  const base64 = encodedOrganizationId.replace(/-/g, '+').replace(/_/g, '/')
  const orgId = window.atob(base64)

  localStorage.setItem('current-organization-unit-id', orgId)

  const newQuery = { ...to.query }
  delete newQuery.o

  return {
    path: to.path,
    hash: to.hash,
  }
}
